<template>
    <Teleport to="body">
        <div
            v-if="props.modelValue"
            class="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4"
            @click.self="close"
        >
            <div
                class="bg-surface-card text-white rounded-lg shadow-2xl w-full"
                :style="{ maxWidth: props.maxWidth ?? '420px' }"
            >
                <slot />
            </div>
        </div>
    </Teleport>
</template>

<script setup lang="ts">
    const props = defineProps<{
        modelValue: boolean
        maxWidth?: string
    }>()

    const emit = defineEmits<{
        'update:modelValue': [value: boolean]
    }>()

    function close() {
        emit('update:modelValue', false)
    }
</script>
